import moment from 'moment'

export const navbarBrand = 'Your News'
export const header = (category) => `News - Top ${category} Headlines`
export const noFound = 'No Results Found'
export const searching = 'Searching...'
export const arrow = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    <path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
  </svg>
)

export const navs = [
  { nav: 'Home', page: '/news' },
  { nav: 'General', page: 'news/categories/general' },
  { nav: 'Business', page: 'news/categories/business' },
  { nav: 'Sports', page: 'news/categories/sports' },
  { nav: 'Science', page: 'news/categories/science' },
  { nav: 'Health', page: 'news/categories/health' },
  { nav: 'Entertainment', page: 'news/categories/entertainment' },
  { nav: 'Technology', page: 'news/categories/technology' },
]

export const router = [
  { path: '/', key: 'general', category: 'general', country: 'us' },
  { path: '/news', key: 'general', category: 'general', country: 'us' },
  {
    path: 'news/categories/general',
    key: 'general',
    category: 'general',
    country: 'us',
  },
  {
    path: 'news/categories/business',
    key: 'business',
    category: 'business',
    country: 'us',
  },
  {
    path: 'news/categories/sports',
    key: 'sports',
    category: 'sports',
    country: 'us',
  },
  {
    path: 'news/categories/science',
    key: 'science',
    category: 'science',
    country: 'us',
  },
  {
    path: 'news/categories/health',
    key: 'health',
    category: 'health',
    country: 'us',
  },
  {
    path: 'news/categories/entertainment',
    key: 'entertainment',
    category: 'entertainment',
    country: 'us',
  },
  {
    path: 'news/categories/technology',
    key: 'technology',
    category: 'technology',
    country: 'us',
  },
]

export const summary = 'Channel and PublishedAt'
export const newsChannel = (channel) => `${channel}`
export const lastUpdate = (published) =>
  `${moment(published).format('ddd, DD MMM YYYY HH:mm:ss')}`
